<div class="content">
    <div class="rhythm-copy">
        <p class="eyebrow" showleft [showDelay]="60">The Veyora rhythm</p>
        <h2 showleft [showDelay]="130">A softer kind of momentum.</h2>
        <p showleft [showDelay]="200">We are drawn to pieces that do not demand a separate version of you for training,
            errands, recovery, or meeting a friend after class. The same quiet confidence should carry through all of
            it.</p>
    </div>
    <div class="rhythm-visual" showright [showDelay]="100">
        <img ngSrc="/images/about/veyora-about-community.webp" fill
            alt="Women in Veyora Fit style activewear resting together after movement">
        <div class="orbit orbit-one" aria-hidden="true"></div>
        <div class="orbit orbit-two" aria-hidden="true"></div>
    </div>
</div>
